import { PDFDocument } from "pdf-lib";

/**
 * @param {Blob|null} codingBlob
 * @param {Blob|null} aiBlob 
 * @returns {Promise<Blob|null>}
 */
export const mergePdfBlobs = async (codingBlob, aiBlob) => {
  const hasCoding = codingBlob && codingBlob.size > 0;
  const hasAi = aiBlob && aiBlob.size > 0;

  if (hasCoding && hasAi) {
    const mergedPdf = await PDFDocument.create();

    const codingBuffer = await codingBlob.arrayBuffer();
    const codingPdf = await PDFDocument.load(codingBuffer);
    const codingPages = await mergedPdf.copyPages(
      codingPdf,
      codingPdf.getPageIndices()
    );
    codingPages.forEach((page) => mergedPdf.addPage(page));

    const aiBuffer = await aiBlob.arrayBuffer();
    const aiPdf = await PDFDocument.load(aiBuffer);
    const aiPages = await mergedPdf.copyPages(aiPdf, aiPdf.getPageIndices());
    aiPages.forEach((page) => mergedPdf.addPage(page));

    const mergedPdfBytes = await mergedPdf.save();
    return new Blob([mergedPdfBytes], { type: "application/pdf" });
  } else if (hasCoding) {
    return codingBlob;
  } else if (hasAi) {
    return aiBlob;
  }

  return null;
};
